import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import crypto from 'crypto';

import styles from './styles';

import languageIcon from './icon.svg';

import { getString } from '../../helpers/stringHelpers.js';

const LOCALE_REGEX = /[a-z][a-z]_[A-Z][A-Z]/;

const DEFAULT_LOCALE = 'en_NZ';

class LocaleSelector extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.setLocale = this.setLocale.bind(this);
    this.getLocale = this.getLocale.bind(this);
    this.getSha1Digest = this.getSha256Digest.bind(this);

    const digest = this.getSha256Digest();
    const savedLocale = localStorage.getItem(digest);
    const currentLocale = this.getLocale();

    if (
      savedLocale !== null &&
      savedLocale !== 'null' &&
      savedLocale !== currentLocale
    ) {
      // If locale cannot be found, revert to default (English)
      if (locales.find((locale) => locale.urlSegment === savedLocale)) {
        this.setLocale(savedLocale);
      } else {
        this.setLocale(DEFAULT_LOCALE);
      }
    }
  }

  handleChange(event) {
    const { gaEvent } = this.props;

    const locale = event.target.value;
    if (locale) {
      gaEvent('Locale', 'Click', locale);
      this.setLocale(locale);
    }
  }

  setLocale(locale) {
    let redirectUrl = '';

    const urlSegmentMatch = window.location.href.match(LOCALE_REGEX);
    if (urlSegmentMatch) {
      // Try to insert the locale by regex - this only works if there is already a locale in the URL
      redirectUrl = window.location.href.replace(LOCALE_REGEX, locale);
    } else {
      // If there is no locale already in the url, use the substr method to insert the locale into the url
      const urlFirstPart = window.location.origin;
      const urlSecondPart = window.location.href.substr(
        urlFirstPart.length,
        window.location.href.length - urlFirstPart.length + 1
      );
      redirectUrl = urlFirstPart + '/' + locale + urlSecondPart;
    }

    const digest = this.getSha256Digest();
    localStorage.setItem(digest, locale);

    window.location.href = redirectUrl;
  }

  getLocale() {
    const urlSegmentMatch = window.location.href.match(LOCALE_REGEX);

    // Default to en_NZ if no locale detected
    const urlSegment = urlSegmentMatch ? urlSegmentMatch[0] : DEFAULT_LOCALE;

    return urlSegment;
  }

  getSha256Digest() {
    const { customerReference } = this.props;

    const input = 'mykoLocale.' + customerReference;
    const shasum = crypto.createHash('sha256');
    shasum.update(input);
    const digest = shasum.digest('hex');
    return digest;
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Select
          value={this.getLocale()}
          classes={{
            root: classes.localeSelector,
            selectMenu: classes.selectMenu,
          }}
          onChange={this.handleChange}
          disableUnderline
          IconComponent={() => (
            <Hidden smDown>
              <ExpandMoreIcon className={classes.selectorIcon} />
            </Hidden>
          )}
          renderValue={() => (
            <div className={classes.buttonLabel}>
              <img
                src={languageIcon}
                className={classes.languageIcon}
                alt="Language icon"
              />
              <Hidden smDown>
                <span className={classes.buttonLabelText}>
                  {getString('app', 'LANGUAGES_LABEL')}
                </span>
              </Hidden>
            </div>
          )}
          MenuProps={{
            classes: {
              paper: classes.menuPaper,
            },
          }}
        >
          <MenuItem className={classes.menuHeading}>
            <div>
              <Typography component="h5" variant="h5">
                {getString('app', 'LANGUAGES_HEADING')}
              </Typography>
              <Typography component="p" variant="body1">
                {getString('app', 'LANGUAGES_SUBHEADING')}
              </Typography>
            </div>
          </MenuItem>
          {locales.map((locale, key) => (
            <MenuItem value={locale.urlSegment} key={key}>
              {locale.title}
            </MenuItem>
          ))}
        </Select>
      </div>
    );
  }
}

LocaleSelector.propTypes = {
  classes: PropTypes.object.isRequired,
  gaEvent: PropTypes.func.isRequired,
};

export default withStyles(styles)(LocaleSelector);
